import { COVER } from '../../config/constants.js';

/**
 * A single Resonant Pillar: destructible cover that absorbs boss/minion
 * bullets (see Game._blockBossBullets) until its HP runs out. Not solid to
 * movement — it blocks bullets, not bodies — and never blocks the player's
 * own projectiles. Dumb entity by design: CoverSystem owns spawn placement,
 * removal, and the crack/shatter events.
 */
export class CoverPillar {
  constructor({ x, y, hp = COVER.hp }) {
    this.x = x;
    this.y = y;
    this.radius = COVER.radius;
    this.maxHp = hp;
    this.hp = hp;
    this.hitFlashTimer = 0; // same brief flinch convention as every damageable entity
  }

  get alive() {
    return this.hp > 0;
  }

  /** 0 pristine, 1 cracked (≤66% HP), 2 crumbling (≤33%) — drives Game._drawCover. */
  get crackStage() {
    const frac = this.hp / this.maxHp;
    if (frac <= 1 / 3) return 2;
    if (frac <= 2 / 3) return 1;
    return 0;
  }

  takeBulletHit(damage) {
    this.hp = Math.max(0, this.hp - damage);
    this.hitFlashTimer = 0.08;
  }
}
